export default {
  title: 'Novo menu',
  headers: {
    edit_time: 'Editar horário',
  },
  labels: {
    select_all: 'Selecionar tudo',
  },
  fields: {
    name: {
      label: 'Nome',
      placeholder: 'Introduza o nome do menu',
    },
    sorting_order: {
      label: 'Ordem de exibição do menu',
      placeholder: 'Introduza a ordem de exibição do menu',
    },
    has_separate_schedule: {
      label: 'Difere do horário normal de abertura',
    },
    selected_days: {
      label: 'Dias selecionados',
    },
    opening_time: {
      label: 'Hora de abertura',
    },
    closing_time: {
      label: 'Hora de encerramento',
    },
  },
  buttons: {
    add_opening_time: 'Adicionar horário de abertura',
    add: 'Adicionar',
    cancel: 'Cancelar',
    save: 'Guardar',
    close: 'Fechar',
  },
  feedback: {
    missing_info: 'Informação em falta',
  },
  toasts: {
    menu_got_created: 'Menu criado',
    menu_got_updated: 'Menu atualizado',
  },
};
